export const getNormalizedOriginSource = (projectId: Nullable<number>, source: string) => {
  if (projectId) {
    return source;
  } else {
    switch (source) {
      case "R":
        return "dimensions-R";
      case "P":
        return "dimensions-P"; 
      default:
        return `decipher-${source}`;
    }
  }
};

export const getNormalizedOriginSourceLable = (normalizedSource: string )=> {
  switch (normalizedSource){
    case "Decipher": 
      return "Forsta Surveys";
      case "R":
        return "Dimensions-R";
      case "P":
        return "Dimensions-P";
      case "C":
        return "Dimensions-C";
    default: 
      return normalizedSource;
  }
};


